import React, {FC, useEffect, useState} from "react";
import style from "./LoginIcon.module.css";
import {UserOutlined} from "@ant-design/icons";
import {useAppSelector} from "../../../../../hooks/redux";
import {getIsAuth} from "../../../../../store/selectors/authSelector";
import {EnumFog} from "../../../../Utils/FogContainer/FogContainer";
import Authentication from "../../../../Authentication/Authentication";
import ModalPortal from "../../../../../Portals/ModalPortal";

export const LoginIcon: FC = () => {

    const isAuth = useAppSelector(getIsAuth)

    const [isOpenLoginModal, setIsOpenLoginModal] = useState<boolean>(false)


    const loginIconHandler = () => {
        if (!isAuth) {
            setIsOpenLoginModal(true)
        }
    }
    useEffect(() => {
        if (isAuth) {
            setIsOpenLoginModal(false)
        }
    }, [isAuth])


    return <div className={style.userIconWrapper}>
        <UserOutlined onClick={loginIconHandler}/>
        <ModalPortal options={{
            setStateModal: setIsOpenLoginModal,
            fogPower: EnumFog.veryStrong,
            statusModal: isOpenLoginModal
        }}>
            <Authentication isOpenLoginModal={isOpenLoginModal}/>
        </ModalPortal>
    </div>
};